import { CloseButton } from 'react-bootstrap';

const CategoryAccordionCloseButton = ({
  onClick,
}: {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}) => <CloseButton className="me-2" onClick={onClick} />;

export default CategoryAccordionCloseButton;
